<template>
    <div class="dat-wrapper">
        <depositRenderData :data="cdAccountData" :viewButtonText="viewButtonText" :bankHealth="bankHealth" :hasError="hasError" />
    </div>
</template>
<script>
    import depositRenderData from './deposit-render-data.vue';
    import depositPaymentHelper from '~/helpers/deposit-account-api';

    export default {
        props: ['viewButtonText', 'bankHealth'],
        data() {
            return {
                cdAccountData: [],
                hasError: false,
            };
        },
        components: {
            depositRenderData,
        },
        async mounted() {
            await depositPaymentHelper.depositAccountData('lt-rt-cd1').then((response) => {
                if (response.status === true) {
                    this.cdAccountData = response.data;
                } else {
                    this.hasError = true;
                }
            });
        },
    };
</script>
